<template>
  <MainContent>
    <b-card>
      <b-row class="mb-2">
        <b-col cols="12">
          <div class="float-right">
            <b-button class="bd-button" @click="redirectLogin">{{$t('back')}}</b-button>
          </div>
        </b-col>
      </b-row>
      <PrivacyPolicyStatement/>
    </b-card>
    </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import PrivacyPolicyStatement from "../components/PrivacyPolicyStatement";
export default {
  components: {
    MainContent,
    PrivacyPolicyStatement
  },
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>

<i18n src="@/locales/actions.locale"></i18n>
